var React = require('react');

function Analytics (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"chart-up-r","d":"M19.956,6.025H13.53V7.389h4.1l-5.66,5.66L8.306,9.386,1.939,15.753l.964.964,5.4-5.4,3.662,3.662,6.616-6.616v4.1h1.364V7.389h.008Z","transform":"translate(-1.939 -6.025)","fill":"#b1b1b1"}));
}

Analytics.defaultProps = {"width":"18.017","height":"10.692","viewBox":"0 0 18.017 10.692"};

module.exports = Analytics;

Analytics.default = Analytics;
